import stringBuilder from './stringBuilder';

const invalidProductDimensions = ['Medium (M)', 'Regular'];
const validProductDivision = ['FTWR'];

/**
 * { name, division, dimensions, metaData }
 * @param {*} product
 * @param {string} product.name
 * @param {string} product.division
 * @param {string} product.dimensions
 * @param {string} product.metaData
 * @returns {string}
 */
export const createProductName = product => {
  const productName =
    product?.name || product?.copy?.name || product?.metaData?.name || product?.metaData?.copy?.name || '';
  const productDiminsions = product?.dimensions || product?.metaData?.dimensions;
  const productDivision = product?.division || product?.metaData?.division;
  const isValidDimensions =
    productDiminsions &&
    productDivision &&
    validProductDivision.map(vpd => vpd.toUpperCase()).includes(productDivision.toUpperCase()) &&
    !invalidProductDimensions.map(ipd => ipd.toUpperCase()).includes(productDiminsions.toUpperCase());
  return stringBuilder({ [productName]: productName, [productDiminsions]: isValidDimensions });
};
